import { render } from "./index.vue?vue&type=template&id=1e43145e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/n0m4dz/workspace/projects/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__